import React, { createContext, useContext } from 'react';
import useReducerHook from 'src/hooks/reducer.hook';
import AdminReducer, { defaultState, asyncActions } from 'src/ducks/admin.duck';

// We need to do this, to be able to get the typings of the Reducer
const useReducer = () => {
  return useReducerHook(AdminReducer, defaultState, asyncActions);
};

type IAdminContext = ReturnType<typeof useReducer>;

// Having trouble setting initial values, that's why it is cast to the return type of the reducer
const AdminContext = createContext<Partial<IAdminContext>>({ state: defaultState }) as React.Context<IAdminContext>;

const AdminProvider: React.FC = ({ children }) => {
  const reducer = useReducer();

  return (
    <AdminContext.Provider
      value={{ ...reducer }}
    >
      {children}
    </AdminContext.Provider>
  );
};

// We create context hook here so that we can able to unit test
// container components that uses this context
export const useAdminContext = () => useContext(AdminContext);

export type IUseAdminContext = ReturnType<typeof useAdminContext>;

export { AdminContext, AdminProvider };
